import ZlgCloudHelper from './zlgcloudhelper.js'
export const ZWSHelper = {
  // 登录
  login (username, password) {
    return ZlgCloudHelper.login(username, password)
  },
  // 重置密码
  resetPassword (username, password, code) {
    return ZlgCloudHelper.resetPassword(username, password, code)
  }
}



// WEBPACK FOOTER //
// ./src/native/ZWSHelper.js